export const PROVEEDOR_CONSTANTS = {
  DIALOG_CONFIG: {
    MAX_WIDTH: 'md' as const,
    DEFAULT_TITLE: 'Editar Proveedor',
  },

  FIELD_LABELS: {
    razonSocial: 'Razón Social *',
    idTipoIdentificacion: 'Tipo Identificación *',
    identificacion: 'Identificación *',
    nombreFantasia: 'Nombre de Fantasía',
    personaContacto: 'Persona de Contacto',
    correoContacto: 'Email',
    direccion: 'Dirección',
    idGenero: 'Género *',
    idEstado: 'Estado',
    telefono: 'Teléfono',
    idGrupo: 'Grupo',
    idAsociacion: 'Asociación',
  },
} as const;